import React from 'react';
import proptypes from 'prop-types';
import { ListTilePlaceholder } from '@thd-olt-component-react/list-tile';

const { number } = proptypes;

export const LoadingUserLists = ({ numberPlaceholders }) => {
  const placeholders = Array.from(Array(numberPlaceholders));

  return (
    <div
      data-testid="lists-placeholder"
      className="sui-col-span-4 sui-grid sui-gap-3 sui-grid-cols-1 md:sui-grid-cols-2
      lg:sui-grid-cols-3"
    >
      {
        placeholders.map((__, index) => (
          <ListTilePlaceholder key={`placeholder-${index}`} />
        ))
      }
    </div>
  );
};

LoadingUserLists.propTypes = {
  numberPlaceholders: number.isRequired,
};
